module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm3": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-color": "#ea1d24"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../assets/img-cadastro.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "destaque-cadastro"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icone-cadastro.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n              Cadastre e veja seu negócio crescer!\n          ")]), _vm._v(" "), _c('h6', [_vm._v("\n            Venda mais para Condomínios! Conheça a ferramenta que coloca sua empresa em contato com quem compra!\n          ")])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "no-bar ajuste-scroll",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md9": ""
    }
  }, [_c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-flex', {
    staticClass: "no-bar posCadastro",
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cadastroCompleto),
      expression: "cadastroCompleto"
    }],
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("\n                  Olá, " + _vm._s(_vm.nomeCompleto) + "\n                ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n                  enviaremos em instantes um e-mail para "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "email-vermelho"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(", para confirmar seu cadastro.\n                ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n                  se não chegou ainda, aguarde um pouquinho.\n                ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n                  Equipe, Condoplaza\n                ")]), _vm._v(" "), _c('div', {}, [_c('v-btn', {
    staticClass: "btn-red",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("\n                    Finalizar\n                  ")])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-flex', {
    staticClass: "no-bar",
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cadastroCompleto),
      expression: "!cadastroCompleto"
    }],
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    staticClass: "voltar",
    attrs: {
      "to": "/Login"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "titulo"
  }, [_vm._v("Cadastre seu negócio")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "name": "form-cadastro",
      "value": "true"
    },
    model: {
      value: (_vm.formValido),
      callback: function($$v) {
        _vm.formValido = $$v
      },
      expression: "formValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do seu negócio",
      "hint": "Nome fantasia",
      "rules": _vm.nomeFantasiaRegras,
      "count": 60,
      "required": ""
    },
    model: {
      value: (_vm.nomeFantasia),
      callback: function($$v) {
        _vm.nomeFantasia = $$v
      },
      expression: "nomeFantasia"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Documento",
      "hint": "CPF/CNPJ",
      "rules": _vm.documentoRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.mascaraDocumento),
      callback: function($$v) {
        _vm.mascaraDocumento = $$v
      },
      expression: "mascaraDocumento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Seu nome completo",
      "rules": _vm.nomeCompletoRegras,
      "required": ""
    },
    model: {
      value: (_vm.nomeCompleto),
      callback: function($$v) {
        _vm.nomeCompleto = $$v
      },
      expression: "nomeCompleto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone do seu Negócio",
      "hint": "DDD + Numero",
      "persistent-hint": "",
      "rules": _vm.telefoneRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.mascaraTelefone),
      callback: function($$v) {
        _vm.mascaraTelefone = $$v
      },
      expression: "mascaraTelefone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail do seu Negócio",
      "rules": _vm.emailRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Usuário",
      "rules": _vm.usuarioRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.usuario),
      callback: function($$v) {
        _vm.usuario = $$v
      },
      expression: "usuario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Senha",
      "type": "password",
      "rules": _vm.senhaRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Confirme a Senha",
      "type": "password",
      "rules": _vm.senhaComparacaoRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.senhaComparacao),
      callback: function($$v) {
        _vm.senhaComparacao = $$v
      },
      expression: "senhaComparacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('tabela-classes')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ajuste",
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.termosDeUso),
      callback: function($$v) {
        _vm.termosDeUso = $$v
      },
      expression: "termosDeUso"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('div', [_vm._v("Sou representante legal do negócio e li e aceito os")]), _vm._v(" "), _c('TermoLegal'), _vm._v(" e os "), _c('TermoUso')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-green",
    attrs: {
      "round": "",
      "large": "",
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "dark": ""
    },
    on: {
      "click": _vm.cadastrar
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n                     Cadastrar\n                     "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce82620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/index.vue
// module id = 729
// module chunks = 5